import { render, staticRenderFns } from "./TermosDeUsoComponent.vue?vue&type=template&id=170282ac&scoped=true"
import script from "./TermosDeUsoComponent.vue?vue&type=script&lang=js"
export * from "./TermosDeUsoComponent.vue?vue&type=script&lang=js"
import style0 from "./TermosDeUsoComponent.vue?vue&type=style&index=0&id=170282ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170282ac",
  null
  
)

export default component.exports